import { DataMap } from '@shared/utils/dataMapping';
export function getGalleryPageTitle() {
    return 'servicesGallery_pageTitle';
}
export function getDetailsPageTitle() {
    return 'detail_pageTitle';
}
export function getFilterItemRoute({ filterItem, filterValue, filterTileType }) {
    const filter = DataMap[`${filterItem}`][`${filterValue}`];
    const routeArgs = null;
    const params = {
        industry: null,
        category: null,
        product: null,
        search: null,
        serviceType: null
    };
    params[`${filterTileType}`] = filter.UrlKey;
    return {
        routeArgs,
        params
    };
}
export function isFilterItemMatch({ service, filterItem, filterValue }) {
    return service[`${filterItem}`] & DataMap[`${filterItem}`][`${filterValue}`].FilterID;
}
